// extracted by mini-css-extract-plugin
export default {"mainContainer":"OtherWebsites_mainContainer__LgmQF","flashcard":"OtherWebsites_flashcard__bC0Xg","mainText":"OtherWebsites_mainText__LC5DG","link":"OtherWebsites_link__g9xc+"};